//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

const getStats = ()=>{
    return axios.get(API_URL+"/dashboards");
}
const getMoreState = ()=>{

}
const addUsers=(id,data)=>{
    return axios.post(API_URL+"clinics/"+id+"/users",data);
}
const getUsers = (id)=>{
    return axios.get(API_URL+"clinics/"+id+"/users");
}
const getUser = (id,uid)=>{
    return axios.get(API_URL+"clinics/"+id+"/users/"+uid);
}
const updateUser=(userid,clinicid,data)=>{
    return axios 
    .put(API_URL+"clinics/"+clinicid+"/users/"+userid,data)
}
const deleteUser=(userid,clinicid)=>{
    return axios
    .delete(API_URL+"clinics/"+clinicid+"/users/"+userid)
}
const getRoles = ()=>{
    return axios.get(API_URL+"roles");
}
const passwordReset = (clinicid,userid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/users/"+userid+"/reset-password")
}
const getUserReminderSettings=(clinicid,userid)=>{
    return axios 
    .get(API_URL+"clinics/"+clinicid+"/users/"+userid+"/reminder-settings")
}
const updateUserReminderSettings=(clinicid,userid,data)=>{
    return axios 
    .put(API_URL+"clinics/"+clinicid+"/users/"+userid+"/reminder-settings",data)
}
export default {
    addUsers,
    getUsers,
    getUser,
    updateUser,
    deleteUser,
    getRoles,
    passwordReset,
    getUserReminderSettings,
    updateUserReminderSettings
}